(function () {
  var SPRING_MS = 420;
  var SPRING_EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cardsIn(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
  }

  function isShown(card) {
    return !card.hidden;
  }

  function positionsOf(list) {
    var map = new Map();
    list.forEach(function (card) {
      map.set(card, card.getBoundingClientRect());
    });
    return map;
  }

  function play(card, keyframes, options) {
    if (!card.animate || reduceMotion) return null;
    return card.animate(keyframes, options);
  }

  /**
   * Like Next.js ProductCard `layout` — hide/show instantly, spring remaining cards.
   */
  function runFilterAnimation(grid, decideVisibility, onDone) {
    var all = cardsIn(grid);
    var beforeVisible = all.filter(isShown);
    var first = positionsOf(beforeVisible);

    var nextVisible = [];
    var exiting = [];
    var entering = [];

    all.forEach(function (card) {
      var show = decideVisibility(card);
      var wasShown = isShown(card);
      if (show && wasShown) nextVisible.push(card);
      else if (show && !wasShown) entering.push(card);
      else if (!show && wasShown) exiting.push(card);
    });

    exiting.forEach(function (card) {
      card.hidden = true;
      card.style.display = 'none';
      card.style.opacity = '';
      card.style.transform = '';
    });
    entering.forEach(function (card) {
      card.hidden = false;
      card.style.display = '';
    });
    nextVisible.forEach(function (card) {
      card.hidden = false;
      card.style.display = '';
    });

    var afterVisible = all.filter(isShown);

    requestAnimationFrame(function () {
      afterVisible.forEach(function (card) {
        var prev = first.get(card);
        var last = card.getBoundingClientRect();

        if (prev) {
          var dx = prev.left - last.left;
          var dy = prev.top - last.top;
          if (Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) {
            play(
              card,
              [
                { transform: 'translate(' + dx + 'px, ' + dy + 'px)' },
                { transform: 'translate(0, 0)' },
              ],
              { duration: SPRING_MS, easing: SPRING_EASE },
            );
          }
        } else if (entering.indexOf(card) > -1) {
          play(
            card,
            [
              { opacity: 0, transform: 'scale(0.96) translateY(12px)' },
              { opacity: 1, transform: 'scale(1) translateY(0)' },
            ],
            { duration: SPRING_MS, easing: SPRING_EASE },
          );
        }
      });

      if (onDone) onDone(afterVisible.length);
    });
  }

  function updateMeta(grid, empty, pagination, visibleCount, hidePagination) {
    if (empty) empty.hidden = visibleCount > 0;
    if (grid) grid.hidden = visibleCount === 0;
    if (pagination) pagination.hidden = !!hidePagination;
  }

  function cardMatchesQuery(card, query) {
    if (!query) return true;
    var blob = (card.getAttribute('data-search-text') || '').toLowerCase();
    if (!blob) {
      var title = card.querySelector('.product-card__title');
      blob = title ? title.textContent.toLowerCase() : '';
    }
    return blob.indexOf(query) > -1;
  }

  function initShopFilters() {
    var root = document.querySelector('[data-shop-section]');
    if (!root || root.dataset.shopFiltersReady === '1') return;
    root.dataset.shopFiltersReady = '1';

    var form = document.getElementById('FacetFiltersForm');
    var searchInput = root.querySelector('[data-shop-search]');
    var grid = root.querySelector('[data-shop-grid]');
    var empty = root.querySelector('[data-shop-empty]');
    var pagination = root.querySelector('[data-shop-pagination]');
    var results = root.querySelector('.shop-page__results');
    var sectionId = root.dataset.shopSection;
    var searchTimer;
    var catalogPromise = null;
    var catalogProducts = null;

    function refreshRefs() {
      searchInput = root.querySelector('[data-shop-search]');
      grid = root.querySelector('[data-shop-grid]');
      empty = root.querySelector('[data-shop-empty]');
      pagination = root.querySelector('[data-shop-pagination]');
      results = root.querySelector('.shop-page__results');
    }

    function loadCatalog() {
      if (catalogProducts) return Promise.resolve(catalogProducts);
      if (catalogPromise) return catalogPromise;
      var handle = root.dataset.collectionHandle || 'all';
      catalogPromise = (async function () {
        var all = [];
        var page = 1;
        while (page <= 8) {
          var response = await fetch(
            '/collections/' +
              encodeURIComponent(handle) +
              '/products.json?limit=250&page=' +
              page,
          );
          if (!response.ok) break;
          var data = await response.json();
          var batch = data.products || [];
          all = all.concat(batch);
          if (batch.length < 250) break;
          page += 1;
        }
        catalogProducts = all;
        return all;
      })().catch(function () {
        catalogPromise = null;
        return [];
      });
      return catalogPromise;
    }

    function catalogProductMatches(product, query) {
      if (!query) return true;
      var tags = Array.isArray(product.tags) ? product.tags.join(' ') : '';
      var blob = [
        product.title,
        product.product_type,
        product.vendor,
        tags,
        product.body_html || '',
      ]
        .join(' ')
        .replace(/<[^>]+>/g, ' ')
        .toLowerCase();
      return blob.indexOf(query) > -1;
    }

    function clearInjectedSearchCards() {
      if (!grid) return;
      grid.querySelectorAll('[data-search-injected]').forEach(function (card) {
        card.remove();
      });
    }

    function formatCatalogPrice(amount) {
      var value = Number(amount);
      if (isNaN(value)) value = 0;
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: Shopify.currency.active,
          }).format(value);
        } catch (error) {
          /* fall through */
        }
      }
      return 'Rs. ' + value.toFixed(2);
    }

    function catalogPriceHtml(product) {
      var variant = (product.variants && product.variants[0]) || {};
      var price = Number(variant.price != null ? variant.price : product.price) || 0;
      var compare = Number(
        variant.compare_at_price != null
          ? variant.compare_at_price
          : product.compare_at_price,
      );
      var onSale = compare > price;
      var html =
        '<div class="price price--sm' +
        (onSale ? ' price--on-sale' : '') +
        '"><span class="price__row">' +
        '<span class="price__current">' +
        formatCatalogPrice(price) +
        '</span>';
      if (onSale) {
        html +=
          '<span class="price__compare">' + formatCatalogPrice(compare) + '</span>';
      }
      html += '</span></div>';
      return html;
    }

    function buildInjectedCard(product) {
      var image =
        product.images && product.images[0]
          ? product.images[0].src
          : product.featured_image;
      var variant = (product.variants && product.variants[0]) || {};
      var price = Number(variant.price != null ? variant.price : product.price) || 0;
      var compare = Number(
        variant.compare_at_price != null
          ? variant.compare_at_price
          : product.compare_at_price,
      );
      var onSale = compare > price;
      var article = document.createElement('article');
      article.className = 'product-card';
      article.setAttribute('data-product-card', '');
      article.setAttribute('data-product-id', String(product.id));
      article.setAttribute('data-search-injected', '');
      article.setAttribute(
        'data-search-text',
        (product.title + ' ' + (product.body_html || '')).toLowerCase().replace(/<[^>]+>/g, ' '),
      );
      article.innerHTML =
        '<div class="product-card__media">' +
        '<a href="/products/' +
        product.handle +
        '" class="product-card__media-link" aria-label="' +
        product.title.replace(/"/g, '&quot;') +
        '">' +
        (image
          ? '<img class="product-card__image" src="' +
            image +
            '" alt="" loading="lazy" width="480" height="600">'
          : '') +
        '</a>' +
        (onSale ? '<span class="product-card__sale">Sale</span>' : '') +
        '</div>' +
        '<div class="product-card__content">' +
        '<a href="/products/' +
        product.handle +
        '" class="product-card__title-link"><h3 class="product-card__title">' +
        product.title +
        '</h3></a>' +
        '<div class="product-card__footer">' +
        catalogPriceHtml(product) +
        '<a class="btn btn--primary btn--sm product-card__add" href="/products/' +
        product.handle +
        '">View</a></div></div>';
      return article;
    }

    /**
     * Client-side filter like Next.js — searches the full collection catalog
     * (not only the current page), including Gift Cards.
     */
    function applySearchFilter() {
      refreshRefs();
      if (!grid || !searchInput) return;
      var query = searchInput.value.trim().toLowerCase();

      if (!query) {
        clearInjectedSearchCards();
        runFilterAnimation(
          grid,
          function () {
            return true;
          },
          function (visibleCount) {
            updateMeta(grid, empty, pagination, visibleCount, false);
            document.dispatchEvent(new CustomEvent('shop:filtered'));
          },
        );
        return;
      }

      // Instant feedback on cards already in the DOM
      runFilterAnimation(
        grid,
        function (card) {
          return cardMatchesQuery(card, query);
        },
        function (visibleCount) {
          updateMeta(grid, empty, pagination, visibleCount, true);
        },
      );

      loadCatalog().then(function (products) {
        if (!searchInput || searchInput.value.trim().toLowerCase() !== query) return;
        refreshRefs();
        if (!grid) return;

        var matches = products.filter(function (product) {
          return catalogProductMatches(product, query);
        });
        var matchIds = matches.map(function (product) {
          return String(product.id);
        });

        clearInjectedSearchCards();

        var existingIds = {};
        cardsIn(grid).forEach(function (card) {
          existingIds[String(card.dataset.productId)] = card;
          var show = matchIds.indexOf(String(card.dataset.productId)) > -1;
          card.hidden = !show;
          card.style.display = show ? '' : 'none';
        });

        matches.forEach(function (product) {
          if (existingIds[String(product.id)]) return;
          grid.appendChild(buildInjectedCard(product));
        });

        var visibleCount = cardsIn(grid).filter(isShown).length;
        updateMeta(grid, empty, pagination, visibleCount, true);
        document.dispatchEvent(new CustomEvent('shop:filtered'));
      });
    }

    function bindSearch() {
      if (!searchInput || searchInput.dataset.searchBound === '1') return;
      searchInput.dataset.searchBound = '1';
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(applySearchFilter, 0);
      });
      searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          clearTimeout(searchTimer);
          applySearchFilter();
        }
      });
    }

    function animateIncomingGrid(oldPositionsById) {
      refreshRefs();
      if (!grid || reduceMotion) return;

      cardsIn(grid).forEach(function (card, index) {
        var prev = oldPositionsById.get(card.dataset.productId);
        var last = card.getBoundingClientRect();

        if (prev) {
          var dx = prev.left - last.left;
          var dy = prev.top - last.top;
          if (Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) {
            play(
              card,
              [
                { transform: 'translate(' + dx + 'px, ' + dy + 'px)' },
                { transform: 'translate(0, 0)' },
              ],
              { duration: SPRING_MS, easing: SPRING_EASE },
            );
            return;
          }
        }

        play(
          card,
          [
            { opacity: 0, transform: 'scale(0.96) translateY(12px)' },
            { opacity: 1, transform: 'scale(1) translateY(0)' },
          ],
          {
            duration: SPRING_MS,
            delay: Math.min(index * 28, 168),
            easing: SPRING_EASE,
            fill: 'both',
          },
        );
      });
    }

    function fetchFilteredResults() {
      if (!form || !sectionId) {
        if (form) form.submit();
        return;
      }

      refreshRefs();
      var oldById = new Map();
      if (grid) {
        cardsIn(grid)
          .filter(isShown)
          .forEach(function (card) {
            oldById.set(card.dataset.productId, card.getBoundingClientRect());
          });
      }

      var params = new URLSearchParams(new FormData(form));
      params.set('sections', sectionId);
      var current = new URLSearchParams(window.location.search);
      if (current.get('view')) params.set('view', current.get('view'));

      var requestUrl = window.location.pathname + '?' + params.toString();
      var historyParams = new URLSearchParams(new FormData(form));
      if (current.get('view')) historyParams.set('view', current.get('view'));
      var historyUrl =
        window.location.pathname +
        (historyParams.toString() ? '?' + historyParams.toString() : '');

      var searchValue = searchInput ? searchInput.value : '';
      form.setAttribute('aria-busy', 'true');
      if (results) results.classList.add('is-filtering');
      // Only show skeleton cards if the request is noticeably slow — avoids a flash.
      var skeletonTimer = setTimeout(function () {
        if (results) results.setAttribute('data-skeleton', '');
      }, 250);

      fetch(requestUrl, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Filter request failed');
          return response.json();
        })
        .then(function (data) {
          var html = data[sectionId];
          if (!html) throw new Error('Missing section HTML');

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextRoot = doc.querySelector('[data-shop-section]') || doc;
          var nextResults = nextRoot.querySelector('.shop-page__results');
          var nextFilters = nextRoot.querySelector('.shop-page__filters');
          if (!nextResults || !results) throw new Error('Missing results');

          var currentFilters = root.querySelector('.shop-page__filters');
          if (currentFilters && nextFilters) {
            currentFilters.innerHTML = nextFilters.innerHTML;
          }

          results.innerHTML = nextResults.innerHTML;
          refreshRefs();
          bindFilterControls();
          bindFiltersDrawer();
          if (searchInput) {
            searchInput.dataset.searchBound = '';
            searchInput.value = searchValue;
          }
          bindSearch();
          if (searchValue) applySearchFilter();

          var nextFab = nextRoot.querySelector('[data-shop-filters-open]');
          var currentFab = root.querySelector('[data-shop-filters-open]');
          if (currentFab && nextFab) {
            currentFab.innerHTML = nextFab.innerHTML;
          }

          animateIncomingGrid(oldById);
          window.history.replaceState({}, '', historyUrl);
          document.dispatchEvent(new CustomEvent('shop:filtered'));
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          clearTimeout(skeletonTimer);
          form.removeAttribute('aria-busy');
          refreshRefs();
          if (results) {
            results.classList.remove('is-filtering');
            results.removeAttribute('data-skeleton');
          }
        });
    }

    function bindFiltersDrawer() {
      var panel = root.querySelector('[data-shop-filters-panel]');
      var scrim = root.querySelector('[data-shop-filters-scrim]');
      var openBtn = root.querySelector('[data-shop-filters-open]');
      if (!panel || !openBtn) return;

      function isMobileDrawer() {
        return window.matchMedia('(max-width: 767px)').matches;
      }

      function setOpen(open) {
        if (!isMobileDrawer() && open) return;
        panel.classList.toggle('is-open', open);
        if (scrim) {
          scrim.classList.toggle('is-open', open);
          scrim.hidden = !open;
          scrim.setAttribute('aria-hidden', open ? 'false' : 'true');
        }
        openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('shop-filters-open', open);
        if (open) {
          var focusTarget =
            panel.querySelector('[data-shop-search]') ||
            panel.querySelector('[data-shop-filters-close]');
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        } else {
          openBtn.focus({ preventScroll: true });
        }
      }

      function closeDrawer() {
        setOpen(false);
      }

      function openDrawer() {
        setOpen(true);
      }

      openBtn.onclick = openDrawer;
      if (scrim) scrim.onclick = closeDrawer;
      panel.querySelectorAll('[data-shop-filters-close]').forEach(function (btn) {
        btn.onclick = closeDrawer;
      });

      if (root.dataset.filtersDrawerEscBound !== '1') {
        root.dataset.filtersDrawerEscBound = '1';
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && panel.classList.contains('is-open')) {
            closeDrawer();
          }
        });
        window.addEventListener('resize', function () {
          if (!isMobileDrawer() && panel.classList.contains('is-open')) {
            closeDrawer();
          }
        });
      }
    }

    function bindFilterControls() {
      if (!form) return;
      form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.onchange = function () {
          fetchFilteredResults();
        };
      });
      var sortSelect = form.querySelector('select[name="sort_by"]');
      if (sortSelect) {
        sortSelect.onchange = function () {
          fetchFilteredResults();
        };
      }
      form.querySelectorAll('[data-price-input]').forEach(function (input) {
        input.onchange = function () {
          fetchFilteredResults();
        };
      });
    }

    bindFilterControls();
    bindSearch();
    bindFiltersDrawer();

    var params = new URLSearchParams(window.location.search);
    if (params.get('view') === 'wishlist') {
      var heading = document.querySelector('[data-collection-heading]');
      var subheading = document.querySelector('[data-collection-subheading]');
      if (heading) heading.textContent = 'Your wishlist';
      if (subheading) subheading.textContent = 'Products you have saved for later.';
    }
  }

  document.addEventListener('DOMContentLoaded', initShopFilters);
  document.addEventListener('shopify:section:load', function () {
    var root = document.querySelector('[data-shop-section]');
    if (root) root.dataset.shopFiltersReady = '';
    initShopFilters();
  });
})();
